<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 4.125H0V19.875H24V4.125Z" fill="#012169" />
  <path d="M9.93281 9.94219V9.20156L2.12812 4.125H0V5.71875L6.49219 9.94219H9.93281Z" fill="white" />
  <path d="M9.93281 14.0576H6.63281L0 18.3654V19.8748H2.26875L9.93281 14.8826V14.0576Z" fill="white" />
  <path d="M21.9186 4.125L14.0576 9.22969V9.94219H17.5545L23.9998 5.74688V4.125H21.9186Z" fill="white" />
  <path d="M14.0576 14.0576V14.8545L21.7873 19.8748H23.9998V18.3373L17.4232 14.0576H14.0576Z" fill="white" />
  <path
    d="M24 9.94219H14.0578V4.125H9.93281V9.94219H0V14.0578H9.93281V19.875H14.0578V14.0578H24V9.94219Z"
    fill="white"
  />
  <path
    d="M24 10.7531H13.2422V4.125H10.7578V10.7531H0V13.2375H10.7578V19.875H13.2422V13.2375H24V10.7531Z"
    fill="#C8102E"
  />
  <path d="M9.10781 9.94219L0.159375 4.125H0V5.025L7.56094 9.94219H9.10781Z" fill="#C8102E" />
  <path d="M9.93281 14.0576H8.39531L0 19.5186V19.8748H0.99375L9.93281 14.0576Z" fill="#C8102E" />
  <path d="M14.7422 14.0576L23.6906 19.8748H24V19.0686L16.2891 14.0576H14.7422Z" fill="#C8102E" />
  <path d="M22.9967 4.125L14.0576 9.93281V9.94219H15.5951L23.9998 4.48125V4.125H22.9967Z" fill="#C8102E" />
</svg>
